import { render, staticRenderFns } from "./TermoRetirada.vue?vue&type=template&id=636e37dc&"
import script from "./TermoRetirada.vue?vue&type=script&lang=js&"
export * from "./TermoRetirada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports